import { render } from "./IPSet.vue?vue&type=template&id=e616f4ba&scoped=true"
import script from "./IPSet.vue?vue&type=script&lang=js"
export * from "./IPSet.vue?vue&type=script&lang=js"

import "./IPSet.vue?vue&type=style&index=0&id=e616f4ba&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e616f4ba"]])

export default __exports__